import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('drawingModeDropdown');

    return {
        APPLY: t('apply'),
        NO_ENTRY: t('noEntry')
    };
};

export default useTranslation;
